export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.666 13.333V6.666a3.333 3.333 0 013.333-3.333h5.834V5H4.999c-.92 0-1.666.746-1.666 1.666v6.667c0 .92.746 1.667 1.666 1.667h5.834v1.666H4.999a3.333 3.333 0 01-3.333-3.333zM18.228 5.833h-1.785a1.674 1.674 0 00-.61-.61V3.438a3.34 3.34 0 012.395 2.395zM15.833 14.777c.253-.147.464-.358.61-.61h1.785a3.34 3.34 0 01-2.395 2.394v-1.784zM14.166 3.333h-1.667V5h1.667V3.333zM18.333 7.5h-1.667v1.666h1.667V7.5z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.333 8.333h-2.5V10h2.5V8.333zM16.666 10.833h1.667V12.5h-1.667v-1.667zM12.5 15h1.666v1.666h-1.667V15z" />`,
  title: 'Virtual Card',
  viewBox: '0 0 21 20',
};
